export const isValidEmail = (email: string) => {
  // Define the regular expression for email validation
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return email.trim() !== '' && emailRegex.test(email);
};

export const isReferenceNumberValid = (value: string): { isValid: boolean; message: string } => {
  if (!/^\d+$/.test(value)) {
    return { isValid: false, message: "Reference number must only contain numeric values." };
  }

  const num = parseInt(value, 10);

  if (num < 100000000 || num > 999999999) {
    return { isValid: false, message: "Reference number must be 9 digits long." };
  }

  return { isValid: true, message: "" };
};


export const isValidCity = (city: string) => {
  // Define the regular expression for city validation
  const cityRegex = /^[a-zA-Z\s\-']+$/;
  return city.trim() !== '' && cityRegex.test(city);
};


// (?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@'#.$;%^&+=!()*,-/_:<>?])[A-Za-z\d@'#.$;%^&+=!()*,-/_:<>?
export const isValidPassword = (password: string) => {
  // Define the regular expression for email validation
  const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*]).{8,}$/;

  // /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&#()^_.])[A-Za-z\d@$!%*?&]{8,}$/;

  // const emailRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@'#.$;%^&+=!()*,-/_:<>?])[A-Za-z\d@'#.$;%^&+=!()*,-/_:<>?$/
  return password.trim() !== '' && passwordRegex.test(password);
};

export const isValidPositiveNumber = (num: string) => /^[0-9]\d*$/.test(num);
export const isValidPhoneNum = (num: string) => /^\d{10}$/.test(num);
